/**
 * @generated SignedSource<<914bceee4d542bb36d9b5ce3dcd4f8fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionBinAndBid_item$data = {
  readonly relevantAuctionSolution: {
    readonly hasReserve: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"OriginalListPrice_item" | "PdpSharedAuctionCountdown_item" | "PdpSharedAuctionPercentageOff_item" | "PdpSharedBuyItNowButton_item" | "PdpSharedPurchaseButton_item" | "PriceDisplay_item" | "useAuctionPricing_item">;
  readonly " $fragmentType": "PdpSharedAuctionActionBinAndBid_item";
};
export type PdpSharedAuctionActionBinAndBid_item$key = {
  readonly " $data"?: PdpSharedAuctionActionBinAndBid_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBinAndBid_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBinAndBid_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OriginalListPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdown_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionPercentageOff_item"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasReserve",
          "storageKey": null
        }
      ],
      "storageKey": "relevantAuctionSolution(page:\"pdp\")"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "831de3d87acf74216a8ffd2358185dd2";

export default node;
